module.exports = __webpack_public_path__ + "static/media/EnergySmartFull.06a0d876.svg";